import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getAllSalads,
  getSingleSaladById,
  createSalad,
  updateSalad,
  deleteSalad,
} from "@/api/new-api/staff-management/menu-manage/essential-menu/salads";

// Thunks

export const fetchAllSalads = createAsyncThunk(
  "salads/fetchAll",
  async ({ restaurant_id, menu_id }, { rejectWithValue }) => {
    const res = await getAllSalads(restaurant_id, menu_id);
    if (res.status === "success") return res.data.salads;
    return rejectWithValue(res.message);
  }
);

export const fetchSingleSalad = createAsyncThunk(
  "salads/fetchOne",
  async (id, { rejectWithValue }) => {
    const res = await getSingleSaladById(id);
    if (res.status === "success") return res.data.salad;
    return rejectWithValue(res.message);
  }
);

export const createNewSalad = createAsyncThunk(
  "salads/create",
  async (data, { rejectWithValue }) => {
    const res = await createSalad(data);
    if (res.status === "success") return res.data.salad;
    return rejectWithValue(res.message);
  }
);

export const updateExistingSalad = createAsyncThunk(
  "salads/update",
  async ({ id, data }, { rejectWithValue }) => {
    const res = await updateSalad(id, data);
    if (res.status === "success") return res.data.salad;
    return rejectWithValue(res.message);
  }
);

export const deleteSaladById = createAsyncThunk(
  "salads/delete",
  async (id, { rejectWithValue }) => {
    const res = await deleteSalad(id);
    if (res.status === "success") return id;
    return rejectWithValue(res.message);
  }
);

// Initial State

const initialState = {
  salads: [],
  singleSalad: null,

  getLoading: false,
  createLoading: false,
  updateLoading: false,
  deleteLoading: false,

  success: null,
  error: null,
  requestStatus: false,
};

// Slice

const saladSlice = createSlice({
  name: "salads",
  initialState,
  reducers: {
    clearSaladMessages: (state) => {
      state.success = null;
      state.error = null;
      state.requestStatus = false;
    },
  },
  extraReducers: (builder) => {
    builder

      // Fetch All
      .addCase(fetchAllSalads.pending, (state) => {
        state.getLoading = true;
        state.error = null;
        state.requestStatus = false;
      })
      .addCase(fetchAllSalads.fulfilled, (state, action) => {
        state.getLoading = false;
        state.salads = action.payload;
        state.requestStatus = true;
      })
      .addCase(fetchAllSalads.rejected, (state, action) => {
        state.getLoading = false;
        state.error = action.payload;
        state.requestStatus = false;
      })

      // Fetch Single
      .addCase(fetchSingleSalad.pending, (state) => {
        state.getLoading = true;
        state.error = null;
        state.requestStatus = false;
      })
      .addCase(fetchSingleSalad.fulfilled, (state, action) => {
        state.getLoading = false;
        state.singleSalad = action.payload;
        state.requestStatus = true;
      })
      .addCase(fetchSingleSalad.rejected, (state, action) => {
        state.getLoading = false;
        state.error = action.payload;
        state.requestStatus = false;
      })

      // Create
      .addCase(createNewSalad.pending, (state) => {
        state.createLoading = true;
        state.error = null;
        state.requestStatus = false;
      })
      .addCase(createNewSalad.fulfilled, (state, action) => {
        state.createLoading = false;
        state.salads.push(action.payload);
        state.success = "Salad created successfully!";
        state.requestStatus = true;
      })
      .addCase(createNewSalad.rejected, (state, action) => {
        state.createLoading = false;
        state.error = action.payload;
        state.requestStatus = false;
      })

      // Update
      .addCase(updateExistingSalad.pending, (state) => {
        state.updateLoading = true;
        state.error = null;
        state.requestStatus = false;
      })
      .addCase(updateExistingSalad.fulfilled, (state, action) => {
        state.updateLoading = false;
        state.salads = state.salads.map((salad) =>
          salad.id === action.payload.id ? action.payload : salad
        );
        state.success = "Salad updated successfully!";
        state.requestStatus = true;
      })
      .addCase(updateExistingSalad.rejected, (state, action) => {
        state.updateLoading = false;
        state.error = action.payload;
        state.requestStatus = false;
      })

      // Delete
      .addCase(deleteSaladById.pending, (state) => {
        state.deleteLoading = true;
        state.error = null;
      })
      .addCase(deleteSaladById.fulfilled, (state, action) => {
        state.deleteLoading = false;
        state.salads = state.salads.map((item) =>
          item.id === action.payload ? { ...item, status: "archive" } : item
        );
        state.success = "Salad deleted successfully!";
        state.requestStatus = true;
      })
      .addCase(deleteSaladById.rejected, (state, action) => {
        state.deleteLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearSaladMessages } = saladSlice.actions;
export default saladSlice.reducer;
